export const configSlideHome = [
    {
        img: '/images/personas_banner.png',
        imgMobile: '/images/personas_banner_mb.png',
        title_img: 'cecol',
        title: 'Certificado de competencias Laborales',
        description: 'El certificado de competencia laboral atesta los conocimientos, habilidades y destrezas que posee una persona para desempeñarse con éxito en el ámbito laboral.'
    },
    {
        img: '/images/mujer-servicio-tel.png',
        imgMobile: '/images/mujer-servicio-tel_mb.png',
        title_img: 'cecol',
        title: 'Persona competente en atención y servicio al cliente',
        description: 'El certificado de competencia laboral atesta los conocimientos, habilidades y destrezas que posee una persona para desempeñarse con éxito en el ámbito laboral.'    
    },
    {
        img: '/images/guardia-seguridad-lugar-trabajo.png',
        imgMobile: '/images/guardia-seguridad-lugar-trabajo_mb.png',
        title_img: 'cecol',
        title: 'Vigilante competente en servicios de seguridad privada',
        description: 'El certificado de competencia laboral atesta los conocimientos, habilidades y destrezas que posee una persona para desempeñarse con éxito en el ámbito laboral.'    
    },
    {
        img: '/images/guardias-seguridad-lugar-trabajo.png',
        imgMobile: '/images/guardias-seguridad-lugar-trabajo_mb.png',
        title_img: 'cecol',
        title: 'Supervisor competente en servicios de vigilancia y seguridad privada',
        description: 'El certificado de competencia laboral atesta los conocimientos, habilidades y destrezas que posee una persona para desempeñarse con éxito en el ámbito laboral.'    
    },
    {
        img: '/images/guardia-seguridad-que-protege-al-cliente.png',
        imgMobile: '/images/guardia-seguridad-que-protege-al-cliente_mb.png',
        title_img: 'cecol',
        title: 'Escolta competente en protección de personas',
        description: 'El certificado de competencia laboral atesta los conocimientos, habilidades y destrezas que posee una persona para desempeñarse con éxito en el ámbito laboral.'    
    },
    {
        img: '/images/retrato-guardia-pantallas.png',
        imgMobile: '/images/retrato-guardia-pantallas_mb.png',
        title_img: 'cecol',
        title: 'Operador de medios tecnológicos competente en vigilancia y seguridad privada',
        description: 'El certificado de competencia laboral atesta los conocimientos, habilidades y destrezas que posee una persona para desempeñarse con éxito en el ámbito laboral.'    
    }
]

export const fichasHome = [
    {
        title: 'Vigilante competente en servicios de seguridad privada',
        urlIcon: '/images/icon-security-1.png',
        titleRedirect: 'Leer más',
        urlRedirect: '/esquemas-certificacion#vigilante'
    },
    {
        title: 'Supervisor competente en servicios de vigilancia y seguridad privada',
        urlIcon: '/images/Vector (1).png',
        titleRedirect: 'Leer más',
        urlRedirect: '/esquemas-certificacion#supervisor'
    },
    {
        title: 'Escolta competente en protección de personas',
        urlIcon: '/images/icon-security.png',
        titleRedirect: 'Leer más',
        urlRedirect: '/esquemas-certificacion#escolta'
    },
    {
        title: 'Operador de medios tecnológicos competente en vigilancia y seguridad privada',
        urlIcon: '/images/icon-camera.png',
        titleRedirect: 'Leer más',
        urlRedirect: '/esquemas-certificacion#operador'
    },
    {
        title: 'Persona competente en atención y servicio al cliente',
        urlIcon: '/images/icon-contact.png',
        titleRedirect: 'Leer más',
        urlRedirect: '/esquemas-certificacion#atencion-servicio'
    }
]

export const configSlideHomeBotton = [
    {
        img: '/images/JuanFelipe.jpg',
        title_img: 'cecol',
        description: 'El equipo de profesionales se destaca por ofrecer un proceso inigualable de certificación. ',
        name: 'Juan Lozano',    
        profession: 'Director Nacional de operaciones',
    },
    {
        img: '/images/ernesto.png',
        title_img: 'cecol',
        description: 'Son un equipo de profesionales con la mejor economía para garantizar que un buen proceso de certificación. ',
        name: 'Ernesto Escobar',    
        profession: 'Empleado',
    }
]

export const itemsFooter = [
    {    
        title: "Compañia",
        subitems:[
            {
                name: "Quienes somos",
                url: "/quienes-somos"
            },
            {
                name: "Esquemas de certificación",
                url: "/esquemas-certificacion"
            },
            {
                name: "Preguntas frecuentes",
                url: "/preguntas-frecuentes"
            },
            {
                name: "Documentación",
                url: ""
            }
        ]
    },
    {    
        title: "Contáctanos",
        subitems:[
            {
                name: "certificaciones.ccl.sas@gmail.com",
                url: "mailto:certificaciones.ccl.sas@gmail.com"
            },
            {
                name: "321 3725323",
                url: "tel:3213725323"
            },
            {
                name: "Carrera 27A # 74 - 38",
                url: ""
            }
        ]
    }
]

export const configSlideCertified = [
    {
        img: '/images/grupo_personas_trabajando.png',
        imgMobile: '/images/grupo_personas_trabajando_mb.png',
        title_img: 'cecol',
        title: 'En CECOL OCP trabajamos fomentar el crecimiento profesional',
        description: 'El certificado de competencia laboral atesta los conocimientos, habilidades y destrezas que posee una persona para desempeñarse con éxito en el ámbito laboral.'
    },
    {
        img: '/images/grupo_personas_trabajando.png',
        imgMobile: '/images/grupo_personas_trabajando_mb.png',
        title_img: 'cecol',
        title: 'En CECOL OCP trabajamos fomentar el crecimiento profesional',
        description: 'El certificado de competencia laboral atesta los conocimientos, habilidades y destrezas que posee una persona para desempeñarse con éxito en el ámbito laboral.'    
    }
]

export const esquemasCertificacion = [
    {
        id: 'atencion-servicio',
        img: '/images/Cetified_1.png',
        title: 'Persona competente en atención y servicio al cliente',
        description: 'Este esquema abarca una amplia gama de actividades relacionada con la atención y servicio al cliente, principalmente los criterios de conocimiento y desempeño especificados en la norma de referencia bajo los cuales determinamos que la persona es capaz de desenvolverse en diversos cargos en los que se requiera una interacción directa con el consumidor.'
    },
    {
        id: 'vigilante',
        img: '/images/Cetified_2.png',
        title: 'Vigilante competente en servicios de seguridad privada',
        description: 'Evaluamos la pericia demostrada por la persona para desempeñarse de manera eficaz en su rol como Vigilante al aplicar los criterios de la Normativa, en especial lo que tiene que ver con: Control de accesos, Prevenir incidentes y Atender situaciones de crisis, así como los conocimientos aplicados para el desarrollo efectivo de la labor.'
    },
    {
        id: 'supervisor',
        img: '/images/Cetified_3.png',
        title: 'Supervisor competente en servicios de vigilancia y seguridad privada',
        description: 'Mediante la aplicación de este esquema la persona deberá demostrar que cuenta con las habilidades necesarias para supervisar los servicios de seguridad y vigilancia mediante la demostración de evidencias de conocimiento y desempeño según la norma de referencia.'
    },
    {
        id: 'escolta',
        img: '/images/Cetified_4.png',
        title: 'Escolta competente en protección de personas',
        description: 'Esquema de certificación diseñado para constatar que la persona tiene la capacidad para desempeñar su rol en la protección de personas, principalmente idónea para minimizar cualquier situación de riesgo identificada al momento de ejercer su labor.'
    },
    {
        id: 'operador',
        img: '/images/Cetified_5.png',
        title: 'Operador de medios tecnológicos competente en vigilancia y seguridad privada',
        description: 'La persona que desee certificar su competencia deberá ser capaz de manejar herramientas tecnológicas, cámaras de seguridad, analizar la información que hay detrás de ellas y predecir los futuros eventos de riesgo que puedan presentarse.'
    }
]

export const itemsPresentation = {
    mision: {
        image: '/images/concepto-negocio-equipo-cerca 1.png',
        title_img: 'cecol',
        title: 'Vision'
    },
    vision: {
        image: '/images/hombre-negocios-bombilla-encendida-su-mano 1.png',
        title_img: 'cecol',
        title: 'Mision'
    },
    derechos: {
        image: '/images/amigos-felices-biblioteca 1.png',
        title_img: 'Derechos',
        title: 'Derechos'
    },
    deberes: {
        image: '/images/fila-estudiantes-haciendo-examen 1.png',
        title_img: 'Deberes',
        title: 'Deberes'
    }
}

export const politiquesContent = [
    {
        title: 'Política de calidad',
        content: 'CECOL OCP garantiza la prestación de servicios de evaluación y certificación válidos, a partir de la intervención de personal competente y con la experticia necesaria para emitir juicios confiables con relación a los lineamientos de cada esquema de certificación en todas sus etapas. Aplicamos métodos de evaluación justos, equitativos e imparciales sustentados sobre incorporación de elementos que generan valor agregado como: Uso de tecnologías de la información y comunicaciones, Alineación de métodos de evaluación con criterios de conformidad, Retroalimentación permanente y Reafirmación de exámenes. Propendemos por aplicar el enfoque de calidad total que permita la satisfacción de todos los grupos de interés sin distinciones ni favoritismos.'
    },
    {
        title: 'Política de imparcialidad, integridad y objetividad',
        content: `CECOL OCP ha tomado las medidas necesarias a través de instrucciones precisas para que las personas que intervienen en las actividades de evaluación y certificación actúen de manera honrada con los deberes asignados y gestionen oportunamente los posibles conflictos de interés identificados. Los conceptos de conformidad y decisiones de certificación se basan en la demostración de evidencias objetivas por lo que los registros del proceso son fiel reflejo del desempeño de cada candidato durante la aplicación del proceso de certificación sin influencias inaceptables y aplicando en todo momento el principio de imparcialidad.`
    },
    {
        title: 'Política de confidencialidad (Tratamiento de la información)',
        content: 'CECOL OCP cumple con las disposiciones legales para administrar la información a la que tiene acceso respecto de solicitantes, candidatos y personas certificadas, mediante la suscripción de acuerdos de confidencialidad que establecen las directrices para dar tratamiento oportuno a los datos que son suministrados por personal interno y externo utilizándolos única y exclusivamente para el propósito del objeto social. Lo anterior nos permite como organismo confirmar, en su debido momento, el estado de una persona evaluada y/o certificada.'
    },
    {
        title: 'Política de igualdad',
        content: 'CECOL OCP ha instados a todo su personal para que en las interacciones con solicitantes, candidatos, personas certificadas y representantes de grupos de interés apliquen la equidad como principio fundamental de ecuanimidad en todas las fases del proceso de certificación. Nos emancipamos de perjuicios inaceptables que puedan afectar el normal desarrollo de las actividades de registro, evaluación y atestación en función a que tratamos a todas las personas por igual sin preferencias o distinciones que no tengan que ver con los requisitos de cada esquema de certificación.'
    },
    {
        title: 'Política de quejas y apelaciones',
        content: 'CECOL OCP da tratamiento eficaz a las solicitudes de quejas o apelaciones hechas por clientes internos y/o externos mediante la aplicación de un proceso documentado para su recepción, validación e investigación que nos permite decidir las acciones que se tomaran para responderlas de manera objetiva y sin afectar a la persona que la interpone. Lo anterior se gestiona a través de la confirmación de comités independientes que garantizan que cada solicitud se trata y procesa de manera constructiva, imparcial y oportuna.'
    },
    {
        title: 'Política de suspensión y retiro de la certificación',
        content: 'CECOL OCP ha establecido claramente las directrices para tomar decisiones en relación con las certificaciones otorgadas mediante la suscripción de acuerdos ejecutables con las personas que aplican el proceso de certificación y reciben un certificado de conformidad, en los que se establecen las condiciones para el uso permitido y las decisiones relacionadas con suspender, retirar o reducir el alcance cuando se identifiquen acciones que puedan poner en riesgo la confianza sobre el organismo o el uso indebido del documento entregado. De lo anterior se notifica oportunamente a la persona a través de la información pública dada a conocer previo a la aplicación de cada esquema.'
    },
    {
        title: 'Política de precios',
        content: 'Tenemos el compromiso de ofrecer nuestros servicios de certificación cumpliendo con lo establecido en los documentos de orden normativo respecto a las tarifas que deben ser cobradas, por tal motivo publicaremos a la vista de todo el público a través de los medios de comunicación válidos, los valores correspondientes para acceder al proceso de certificación desglosando cada uno de los componentes del servicio.'
    },
    {
        title: 'Política de seguridad',
        content: 'CECOL OCP ha determinado los mecanismos para salvaguardar tanto los registros como los materiales de examen en entornos físicos y digitales seguros a través de la utilización de herramientas que permiten garantizar la seguridad a lo largo de todo el proceso de certificación aplicando las medidas necesarias para una gestión adecuada, entre las que se encuentran: Instalaciones de archivo inocuas, claves de acceso personalizadas y de uso limitado, uso de una plataforma de registro apropiada, servidores seguros de almacenamiento y la garantía que la información obtenida no se alterará ni manipulará de ninguna manera por parte de los responsables de la aplicación de los esquemas de certificación. Durante cada fase del esquema de certificación se previenen las tentativas de fraude a través de mecanismos de identificación de identidad, la firma de un acuerdo ejecutable con los candidatos y tomando las medidas necesarias para que no se afecte el normal desarrollo de cada proceso por medio del personal que supervisa cada fase.'
    },
    {
        title: 'Política de gestión de riesgos',
        content: 'Como parte de nuestra cultura organizacional, se establecen los elementos y el marco general de actuación para gestionar integralmente los riesgos de toda naturaleza a los que se enfrenta el organismo; este enfoque hace parte del Sistema de Gestión de la Calidad implementado y se complementa con la participación activa de los Dueños de Procesos mediante el compromiso adquirido desde la alta dirección para establecer directrices específicas de mitigación que contribuyan al cumplimiento de nuestra Misión y Visión. Esta política se aplica en todos los niveles organizacionales con el fin de prever situaciones y amenazas que puedan afectar los procedimientos, metas y actividades desarrolladas, por lo que se gestionan a través del establecimiento y puesta en marcha de Acciones Preventivas, en las que se definen las actividades para prevenir y mitigar, desde la proactividad, situaciones futuras de cualquier índole relacionadas con el objeto social. De manera general, se considera un riesgo cualquier amenaza de que un evento, acción u omisión pueda impedir al organismo lograr los objetivos y ejecutar sus estrategias con éxito. Enfoque basado en riesgos es la implementación sistemática de un conjunto de acciones tendientes al manejo óptimo de situaciones que puedan afectar positiva o negativamente la estrategia corporativa, los procesos del sistema de gestión, los proyectos o nuevas inversiones y en general todos los aspectos del organismo de tal forma que pueda garantizarse razonablemente el logro de los objetivos de calidad. El ciclo de la gestión de riesgos comprende actividades de identificación de causas, correcciones inmediatas y el establecimiento de planes de acción, así como las acciones de seguimiento para administrarlos.'
    }
]

export const deberesContent = [
    {
        image: '/images/personas_deberes.png',
        title: 'Derechos de los solicitantes',
        content: `• Todo solicitante tiene el derecho a ser admitido al proceso de evaluación para poder obtener su certificado de conformidad. Salvo cuando por vía oral o escrita el organismo exprese que, por condiciones excepcionales tales como el idioma, incumplimiento de prerrequisitos, limitaciones físicas o de infraestructura, fuerza mayor y/o casos fortuitos, no esté en disponibilidad de prestar los servicios de evaluación y certificación, en este caso se debe dejar evidencia escrita de la no competencia del organismo la cual deberá ser aceptada y avalada por el solicitante a través de su rúbrica.

        • No existirán condicionamientos para la aplicación al esquema de certificación que no sean propios y exclusivos del cumplimiento de prerrequisitos determinados en el esquema.

        • Todo solicitante tiene derecho a ser admitido para aspirar al proceso de certificación, sin recibir un trato discriminatorio y sin exclusiones, para su identificación en el sistema deberá obligatoriamente presentar su documento de identidad original (cedula de ciudadanía, tarjeta de identidad, cedula de extranjería o pasaporte), el cual será utilizado para registrarlo en la plataforma digital utilizada para la aplicación de exámenes.

        • Todo solicitante tiene el derecho a conocer el esquema de certificación previo a la aplicación de este, la información publicada sin solicitud previa contendrá aspectos relevantes tales como: Alcance, Tarifas, Derechos y deberes, Descripción general del proceso, Criterios para suspender, retirar o cambiar el alcance, Políticas, Tratamiento de quejas y apelaciones, declaración de imparcialidad e independencia de intereses y Disposiciones generales.
        
        • Todo el personal de planta y subcontratado que participa directa e indirectamente en el proceso de evaluación y certificación está en la obligación de ofrecer a los solicitantes/candidatos un trato imparcial, objetivo y respetuoso durante todo el proceso de aplicación del esquema.

        • De acuerdo con los requerimientos de la normativa legal, jurídica y técnica, así como lo establecido en la NTC ISO/IEC 17024 en su versión actualizada, CECOL OCP es responsable de mantener la confidencialidad y proveer la seguridad necesaria para garantizar la confianza en la reserva de los datos de solicitantes, candidatos y/o personas certificadas, así como de los resultados parciales y totales de las evaluaciones practicadas y certificados otorgados.

        • El solicitante que accede al proceso de certificación tiene derecho a aplicar las evaluaciones para obtener el certificado de conformidad, sin afectar el principio de imparcialidad para cada esquema desarrollado. En caso de presentarse algún conflicto de interés durante el proceso, el organismo tiene la obligación de tomar las medidas y realizar las actividades pertinentes para salvaguardar la objetividad de cada etapa del enfoque funcional.

        • El solicitante que accede al proceso de certificación tiene derecho a finalizar y conocer el resultado del proceso de evaluación y certificación. Así mismo toda persona tiene derecho a manifestar sus quejas y/o apelaciones sobre los conceptos y decisiones tomadas por el organismo a través de examinadores y profesional certificador, caso en el cual, el organismo tendrá la obligación de resolverlas en el menor tiempo posible de acuerdo con los procedimientos internos.

        • Todo solicitante que aplica el proceso y recibe un certificado de conformidad tiene derecho a ser informado por el organismo cuando se haga un cambio en el esquema de certificación que requiera una evaluación complementaria, así como los métodos y mecanismos específicos requeridos para verificar que las personas certificadas cumplen los requisitos modificados.

        • La validez del Certificado de cumplimiento de requisitos de conformidad será aceptada en los términos del alcance otorgado y será utilizado única y exclusivamente para los fines enmarcados en la ley nacional y para los efectos que esta designe.

        • Todo proceso de evaluación y certificación será tomado bajo evidencia objetiva.`
    },
    {
        image: '/images/persona_deberes.png',
        title: 'Deberes de los solicitantes',
        content: `• Las personas certificadas deberán cumplir con las disposiciones establecidas para el uso del certificado entregado los cuales estarán disponibles para su consulta en los registros y documentos publicados.

        • En caso de aceptar el certificado, la persona certificada declara de forma tácita que está conforme respecto a los resultados, decisiones y demás aspectos referentes a la aplicación del proceso de certificación.

        • La persona certificada debe aceptar y acatar las condiciones de uso del certificado y hacer declaraciones relativas a la certificación solo con respecto al alcance otorgado y no utilizar el certificado de manera que pueda inducir al engaño.

        • La persona certificada no debe divulgar información confidencial acerca del proceso de evaluación y no utilizar de manera engañosa ni fraudulenta el certificado otorgado por el organismo.

        • La persona certificada no debe utilizar el certificado de modo que pueda dañar la reputación del organismo de certificación CECOL OCP

        • La persona certificada no debe emitir ninguna declaración relativa a la certificación que se pueda considerar engañosa o no autorizada.

        • La persona certificada debe aceptar que si el certificado otorgado es suspendido o retirado no deberá hacer declaraciones relativas a la certificación que contengan referencias al organismo CECOL OCP o a la certificación misma y devolverá el certificado recibido de manera oportuna.

        • La persona certificada se compromete a informar oportunamente al organismo sobre algún cambio en sus condiciones físicas, aptitudinales y capacidades que puedan afectar su desempeño en relación con el alcance de la certificación otorgada.

        • La persona certificada autoriza expresamente a CECOL OCP a suministrar la información de los resultados del proceso de evaluación y certificación cuando una autoridad competente y debidamente autorizada lo solicite.

        • La persona certificada debe aceptar que el certificado otorgado y demás documentos emanados a partir de la aplicación del esquema de certificación prestan merito ejecutivo y serán utilizados como tal para efectos jurídicos y legales.`
    }
]

export const configSlideAbout = [
    {
        img: '/images/personas_banner.png',
        imgMobile: '/images/about_mb.png',
        title_img: 'cecol',
        title: 'En CECOL OCP trabajamos fomentar el crecimiento profesional',
        description: 'El certificado de competencia laboral garantiza que una persona cuenta con los conocimientos, habilidades y destrezas requeridas para desempeñar una labor específica, teniendo en cuenta los criterios normativos de referencia determinados en normas sectoriales.'
    },
    {
        img: '/images/mujer-servicio-tel.png',
        imgMobile: '/images/about_mb.png',
        title_img: 'cecol',
        title: 'En CECOL OCP trabajamos fomentar el crecimiento profesional',
        description: 'El certificado de competencia laboral garantiza que una persona cuenta con los conocimientos, habilidades y destrezas requeridas para desempeñar una labor específica, teniendo en cuenta los criterios normativos de referencia determinados en normas sectoriales.'    
    }
]